import { useEffect } from "react";

import { Link } from "react-router-dom";
import CashOnDelivery from "./CashOnDelivery";
import QuickPayments from "./QuickPayments";

const EcomSolutions = () => {
  useEffect(() => {
    let current_page = window.location.href.split("/").at(-1);
    setTimeout(() => {
      document
        .getElementById(`${current_page}`)
        ?.scrollIntoView({ block: "center", behavior: "smooth" });
    }, 50);
  });
  window.addEventListener(
    "scroll",
    function (event) {
      let top = this.scrollY,
        window_width = window.innerWidth,
        header_height = document.querySelector("header").style.height + 100;
      // (top > header_height && window_width > 1024) ? document.querySelector("nav").classList.add('fixed-header-desktop') : document.querySelector("nav").classList.remove('fixed-header-desktop')
      top > header_height && window_width > 1024
        ? document.querySelector("a").classList.add("fixed-header-desktop")
        : document.querySelector("a").classList.remove("fixed-header-desktop");
    },
    false,
  );
  window.addEventListener(
    "scroll",
    function (event) {
      let top = this.scrollY,
        window_width = window.innerWidth,
        header_height = document.querySelector("header").style.height + 100;
      top > header_height && window_width > 1024
        ? document.querySelector("nav").classList.add("fixed-header-desktop")
        : document
            .querySelector("nav")
            .classList.remove("fixed-header-desktop");
      // (top > header_height && window_width > 1024) ? document.querySelector("a").classList.add('fixed-header-desktop') : document.querySelector("a").classList.remove('fixed-header-desktop')
    },
    false,
  );

  return (
    <div>
      <div id="international" className="ecom-solution-image">
        <img src="/ecom-solution/main-banner.jpg" alt="" className="w-[100%]" />
      </div>
      <div className="flex flex-col justify-center gap-4 max-w-[50rem] lg:mx-auto md:mx-auto mx-[2rem]  md:p-[2rem] pt-[1rem] lg:pb-[50px]  pb-[1rem]">
        <p>
          No other industry is changing as rapidly and with as much effect as
          the e-commerce industry. The <br /> e-com landscape in Pakistan is at
          an extremely exciting stage given that it is still exploring and
          finding its own feet. The outlook for local entrepreneurs as well as
          venture capitalists remains strong in the medium to long term, which
          has helped many businesses, small and large, to operate successfully
          and to build a customer base that would have been otherwise impossible
          to reach.
        </p>
        <p>
          With e-commerce industry booming and gaining momentum in Pakistan, TCS
          is leading the way, when it comes to bringing everything at the
          doorstep of our customers. When you remove the physical boundaries of
          a store, you offer a plethora of convenience to your customers, and
          this is where TCS can become your partner in making your customers’
          lives convenient and easy.
        </p>

        <div className="MuiFormGroup-root MuiFormGroup-row">
          <div className="sm:flex grid  pb-[50px]">
            <div className="flex-1 flex flex-col">
              <div className="flex items-center ">
                <li>
                  <Link to="/ecom-solution/retail_cod" className="font-bold">
                    Retail COD
                  </Link>
                </li>
              </div>
              <div className="flex items-center mt-[2rem]">
                <Link
                  to="/ecom"
                  className="flex justify-center text-center items-center  text-white bg-[#D40511] border border-[#F21E26] w-[10rem] rounded-md mt-[1rem] p-1 h-[2.5rem] text-sm hover:bg-[#F21E26] hover:text-white transition-all duration-500"
                >
                  Open an Account
                </Link>
              </div>
            </div>

            <div className="flex-1 flex flex-col">
              <div className="flex items-center">
                <li>
                  <Link to="/ecom-solution/quick-payment" className="font-bold">
                    Fulfilment Services
                  </Link>
                </li>
              </div>
            </div>
            <div className="flex-1 flex flex-col">
              <div className=" mt-[1rem] w-[100%]">
                <div className="flex justify-left "></div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="mx-[2rem] md:mx-[0rem]">
        <div id="retail_cod">
          <CashOnDelivery />
        </div>
        <div id="quick-payment">
          <QuickPayments />
        </div>
      </div>
    </div>
  );
};
export default EcomSolutions;
